<div *ngIf="isSuperUser" class="mt-4 border border-gray-200 rounded-lg bg-white">
  <button type="button" (click)="toggle()"
    class="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50 rounded-lg">
    <span class="flex items-center font-semibold text-gray-900">
      <mat-icon class="mr-2 text-gray-500">source</mat-icon>
      Original BMD-Datensatz
      <span class="ml-2 text-xs font-normal px-2 py-0.5 rounded bg-gray-100 text-gray-600">nur Superuser</span>
    </span>
    <mat-icon class="text-gray-500">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>

  <div *ngIf="expanded" class="px-4 pb-4">
    <div *ngIf="loading" class="text-sm text-gray-500 py-2">Lade Originaldaten …</div>
    <div *ngIf="error" class="text-sm text-red-600 py-2">{{ error }}</div>
    <div *ngIf="loaded && !records.length" class="text-sm text-gray-500 py-2">
      Kein Original-Datensatz vorhanden (noch nicht über den BMD-Import eingelesen).
    </div>

    <label *ngIf="records.length" class="flex items-center text-xs text-gray-600 mb-2">
      <input type="checkbox" class="mr-1" [(ngModel)]="showEmpty" /> leere Spalten anzeigen
    </label>

    <div *ngFor="let r of records" class="mb-4 border border-gray-100 rounded">
      <div class="flex flex-wrap items-center gap-2 px-3 py-2 bg-gray-50 text-sm">
        <span class="font-medium text-gray-900">{{ sourceTypeLabel(r.source_type) }}</span>
        <span class="font-mono text-gray-700">{{ r.source_key }}</span>
        <span class="flex-grow"></span>
        <label class="text-xs text-gray-600">Version
          <select [(ngModel)]="selectedVersion[recordKey(r)]" class="ml-1 border border-gray-300 rounded text-xs p-1">
            <option *ngFor="let v of r.versions; let i = index" [ngValue]="i">
              v{{ v.version }} · {{ v.first_seen_at }}{{ i === 0 ? ' (aktuell)' : '' }}
            </option>
          </select>
        </label>
      </div>
      <div class="px-3 py-1 text-xs text-gray-500">
        Datei {{ version(r).filename || '—' }}<span *ngIf="version(r).row_number">, Zeile {{ version(r).row_number }}</span>
        · zuerst {{ version(r).first_seen_at }} · zuletzt gesehen {{ version(r).last_seen_at }}
        <span *ngIf="changedCount(r)" class="ml-1 text-amber-700">· {{ changedCount(r) }} Spalte(n) geändert ggü. Vorversion</span>
        <span *ngIf="!showEmpty && emptyCount(r)"> · {{ emptyCount(r) }} leere Spalten ausgeblendet</span>
      </div>
      <table class="w-full text-xs">
        <tbody>
          <tr *ngFor="let c of columns(r)" class="border-t border-gray-100 align-top" [ngClass]="c.changed ? 'bg-amber-50' : ''">
            <td class="px-3 py-1 font-mono text-gray-600 whitespace-nowrap w-1/4">{{ c.column }}</td>
            <td class="px-3 py-1 text-gray-900 break-words">
              <span *ngIf="c.value.trim() !== ''; else emptyValue" class="whitespace-pre-line">{{ c.value }}</span>
              <ng-template #emptyValue><span class="text-gray-400">leer</span></ng-template>
              <div *ngIf="c.changed" class="text-gray-500">vorher: {{ c.previous || 'leer' }}</div>
            </td>
            <td class="px-3 py-1 whitespace-nowrap w-1/4">
              <span *ngIf="c.target" class="px-1.5 py-0.5 rounded bg-green-100 text-green-800" [title]="c.target">
                importiert → {{ c.target }}
              </span>
              <span *ngIf="!c.target" class="px-1.5 py-0.5 rounded bg-gray-100 text-gray-500">nicht importiert</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
